import React from "react";
import { Container, Anchor, Link, Close } from "./SidebarComponents";

function Sidebar({ isOpen, toggle }) {
  return (
    <Container isOpen={isOpen}>
      <Close onClick={toggle} />
      <Anchor to="what" spy={true} smooth={true} duration={500} onClick={toggle}>
        What?
      </Anchor>
      <Anchor to="why" spy={true} smooth={true} duration={500} onClick={toggle}>Why?</Anchor>
      <Anchor to="pricing" spy={true} smooth={true} duration={500} onClick={toggle}>Pricing</Anchor>
      <Link to="/login">Sign In</Link>
    </Container>
  );
}

export default Sidebar;
